export default "<div>\n  <ion-label>Ukupno</ion-label>\n  <ion-text>{{price}} RSD</ion-text>\n</div>\n";